/* eslint-disable  @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable  @typescript-eslint/explicit-function-return-type */
import { ImgWithParagraphComp } from '../../../components/SwapKiwi/ImgWithParagraph';
import { TitleWithDescription } from '../../../components/SwapKiwi/TitleWithDescription';
import { SupportersContainer } from '../../../components/SwapKiwi/SupportersContainer';
import { BackgroundColor, ImagePosition } from '../../../components/SwapKiwi/TextWithImage';
import { ReactComponent as KiwiLayer3 } from '../../../assets/svg/icons/kiwi-layer-3.svg';
import animoca from '../../../assets/svg/supporters/animoca-light.svg';
import delta from '../../../assets/svg/supporters/delta-light.svg';

export const components = [
  {
    name: ImgWithParagraphComp,
    props: {
      imageSrc: KiwiLayer3,
      imagePosition: ImagePosition.CENTER,
      text:
        'app.swap.kiwi was an innovative platform in the NFT industry. It was dedicated to allowing secure swaps of NFTs between users.',
      background: BackgroundColor.CLOUD,
    },
  },
  {
    name: TitleWithDescription,
    props: {
      title: '🥝 swap.kiwi – A Farewell & Retrospective',
      description:
        'swap.kiwi was a playful, community-driven platform designed for trading digital collectibles and NFTs in a seamless, social, and visually engaging way. Launched as an experimental alternative to traditional NFT marketplaces, swap.kiwi focused on peer-to-peer swapping over pure purchasing — putting the fun and community back into collecting.',
      background: BackgroundColor.CLOUD,
      hasButoon: false,
    },
  },
  {
    name: TitleWithDescription,
    props: {
      title: 'Swap.kiwi in the press',
      description:
        'swap.kiwi built a passionate community of digital artists, collectors, and experimental web3 enthusiasts.',
      background: BackgroundColor.CLOUD,
      hasButton: true,
      buttonURL: 'https://kalis.me/best-nft-trading-peer-to-peer-2021',
    },
  },
  {
    name: TitleWithDescription,
    props: {
      title: 'Sunset',
      description:
        'After a successful run, swap.kiwi shuts down its trading platform, leaving behind a legacy of innovation in digital exchange culture. While the app is no longer active, its spirit lives on in the community it helped build and inspire.',
      background: BackgroundColor.CLOUD,
      hasButoon: false,
    },
  },
  {
    name: SupportersContainer,
    props: {
      title: 'swap.kiwi supporters',
      titleSize: 'sm',
      titleCenter: true,
      description: '',
      background: BackgroundColor.CLOUD,
      supporters: [
        {
          name: 'Animoca Brands',
          imageURL: animoca,
          color: 'cloud',
        },
        {
          name: 'Delta Fund',
          imageURL: delta,
          color: 'cloud',
        },
      ],
    },
  },
];
